import { TemplatesView as ReactTemplatesView } from 'src/views/menus/templates';

const BaseView = require('../components/accordion-list/categories-director');

const SubCategoriesView = require('./sub-categories');

module.exports = BaseView.extend({
  class: 'sub-category template',
  CategoriesView: SubCategoriesView,

  initialize: function () {
    BaseView.prototype.initialize.call(this);
  },

  _render: function () {
    ReactTemplatesView.mountApp();
  },

  getCategoryName: function (data) {
    return data.format.name;
  }
});
